import styled from 'styled-components';

export const HiddedA = styled.a`display:hidden;`;

export const DownloadLink = styled.a<{ disabled?: boolean }>`${({ theme, disabled }) => `
  color: ${disabled ? theme.colours.neutral[5] : theme.colours.link[1]};
  text-decoration: underline;
  font-size: ${theme.fontSize[1]};
  cursor: ${disabled && 'not-allowed'};
`}`;

export const DownloadIcon = styled.i<{ disabled?: boolean }>`${({ theme, disabled }) => `
  color: ${disabled ? theme.colours.neutral[5] : theme.colours.link[1]};
  padding-right: ${theme.padding[1]};
  font-size: ${theme.fontSize[3]};
  cursor: ${disabled && 'not-allowed'};
`}`;
